var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nctaContentContainer", attrs: { "aria-live": "polite" } },
    [
      _c(
        "modal",
        {
          staticClass: "interstitialModal",
          attrs: {
            "is-visible": _vm.isVisible,
            "aria-labelledby": "interstitialHeader"
          },
          on: {
            close: _vm.close,
            "click-overlay": _vm.close,
            "focus-start": _vm.focusStart
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c(
              "div",
              { staticClass: "headerBackgroundImg", style: _vm.styleOverrides },
              [
                _vm.settings.interstitialSmallImageUrl
                  ? _c("img", {
                      staticClass: "logo",
                      attrs: { src: _vm.settings.interstitialSmallImageUrl }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "headerContent" }, [
                  _c("h3", {
                    attrs: { id: "interstitialHeader" },
                    domProps: {
                      innerHTML: _vm._s(_vm.settings.interstitialCopy)
                    }
                  })
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            !_vm.isSubscribed
              ? _c(
                  "section",
                  { staticClass: "interstitialDescriptionContainer" },
                  [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.settings.interstitialDescriptionCopy
                        )
                      }
                    }),
                    _vm._v(" "),
                    !_vm.isSubscribed
                      ? _c("signup", {
                          ref: "anonymousSignup",
                          staticClass: "anonymousSignupContainer",
                          attrs: {
                            config: _vm.settings,
                            newsletter:
                              _vm.newsletters && _vm.newsletters.length > 0
                                ? _vm.newsletters[0]
                                : null,
                            "hint-text":
                              _vm.settings.anonymousEmailAddressLabel,
                            "enable-expanded-fields":
                              _vm.settings.enableExpandedFields,
                            "legal-copy": _vm.settings.interstitialLegalCopy
                          },
                          on: { subscribed: _vm.showThankYou }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _c("div", { staticClass: "anonymousThankYouContent" }, [
                  _c("h3", {
                    domProps: {
                      innerHTML: _vm._s(_vm.settings.anonymousThankYouCopy)
                    }
                  }),
                  _vm._v(" "),
                  _c("p", {
                    attrs: { role: "status" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.settings.anonymousThankYouDescriptionCopy
                      )
                    }
                  }),
                  _vm._v(" "),
                  _vm.regUrl
                    ? _c(
                        "a",
                        {
                          staticClass: "anonymousRegister",
                          attrs: { href: _vm.regUrl }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.settings.registrationLinkText) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ])
          ]),
          _vm._v(" "),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            !_vm.isSubscribed
              ? _c("p", [
                  _vm._v(_vm._s(_vm.settings.alreadyAMemberText) + " "),
                  _c("a", { attrs: { href: _vm.settings.loginUrl } }, [
                    _vm._v(_vm._s(_vm.settings.loginLinkText))
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }